import React, { useEffect, useState } from 'react';
import { Form, FormControl, Row, Button} from 'react-bootstrap';
import { isEmpty } from 'lodash';

import withModal from '../../hoc/withModal';
import withForm from '../../hoc/withForm';

import Spinner from '../../components/Spinner/Spinner';
import InputCollection from '../../components/InputCollection/InputCollection';
import { useNetSuiteAllItemsStore } from '../../store/providers/NetSuiteAllItems';
import OptionsHelper from '../../lib/OptionsHelper';
import { useFranchiseAccountingStore } from '../../store/providers/FranchiseAccounting';
import { useAlertStore } from '../../store/providers/Alert';
import * as constants from '../../constants';


function FeeTypeModal(props) {

    const { listRecords: netSuiteItemsList, data: netSuiteItemsData } = useNetSuiteAllItemsStore();
    const { createNSRecord, data, clearData } = useFranchiseAccountingStore();
    const { addAlert } = useAlertStore();

    const [isMounted, setIsMounted] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [isBusy, setIsBusy] = useState(false);
    const [canEdit, setCanEdit] = useState(false);
    const [netSuiteItemsOptions, setNetSuiteItemsOptions] = useState([]);
    const [saveCorp, setSaveCorp] = useState(true);

    const submittedHandler = (e) => {
        e.preventDefault();
        createNSRecord({ 
            Corp: 0,
            Description: props.formData.description,
            FranchiseId: 0,
            FromTable: props.formData.fromTable,
            ItemId: props.formData.itemId,
            NetsuiteItemId: props.formData.netsuiteItemId,
            NetsuiteNonCorpItemId: props.formData.netsuiteNonCorpItemId,
            Description: props.formData.description,
         });
    };

    useEffect(() => {
        if (!isEmpty(data)) {
            if (data.status === 'fail' || data.status === 'error') {
                addAlert({ key: constants.ALERT_SERVER_ERROR, text: <strong>{data.body}</strong>, type: constants.ALERT_TYPE_DANGER });
                clearData();
            }

            if (data.status === 'success' && data.scope === 'create_netsuitemapping') {
                if(saveCorp === true){
                    setSaveCorp(false);
                    createNSRecord({ 
                        Corp: 1,
                        Description: props.formData.description,
                        FranchiseId: 0,
                        FromTable: props.formData.fromTable,
                        ItemId: props.formData.itemId,
                        NetsuiteItemId: props.formData.netsuiteItemId,
                        NetsuiteNonCorpItemId: props.formData.netsuiteNonCorpItemId,
                        Description: props.formData.description,
                     });
                } else {
                    props.submitted();
                }
            }
        }

        setIsBusy(!isEmpty(data) && (data.status === 'processing' && (data.scope === 'create_netsuitemapping')));
    }, [data, addAlert, clearData, props]);


    useEffect(() => {
        if (isMounted) { return; }
        props.formInitialize(props.feeTypeItem);
        setCanEdit(props.canEdit);
        netSuiteItemsList();
        setIsMounted(true);
    }, [isMounted, props]);

    useEffect(() => {
        if (!isEmpty(netSuiteItemsData) && netSuiteItemsData.scope === 'list' && netSuiteItemsData.status === 'success') {
            let optionvals = netSuiteItemsData.body.map(option => { return { id: option.netSuiteId, name: option.name } })
            setNetSuiteItemsOptions(OptionsHelper({ list: optionvals, includeBlank: true, includeBlankName: 'Select...' }));
            setIsLoaded(true);
        }
        setIsBusy(!isEmpty(netSuiteItemsData) && (netSuiteItemsData.status === 'processing' && (netSuiteItemsData.scope === 'delete' || netSuiteItemsData.scope === 'list')));

    }, [netSuiteItemsData]);

    return (
        <>
            {
                !isLoaded && <Spinner text="Loading Fee Type Mappings..." />
            }
            {
                isLoaded && (
                    <Form id="feeTypeMappingsForm" onSubmit={(e) => submittedHandler(e)}>
                        <Row>
                             <div className="col-md-6">
                                <InputCollection labelText="Netsuite Corp Item">
                                    <FormControl id="netsuiteItemId" componentClass="select"  onChange={(e) => props.formChanged(e.target.id, e.target.value)}  defaultValue={props.feeTypeItem.netsuiteItemId || ''} disabled={!canEdit || isBusy}>
                                        {netSuiteItemsOptions}
                                    </FormControl>
                                </InputCollection>
                            </div>
                            <div className="col-md-6">
                                <InputCollection labelText="Netsuite NonCorp Item">
                                    <FormControl id="netsuiteNonCorpItemId" componentClass="select" onChange={(e) => props.formChanged(e.target.id, e.target.value)}  defaultValue={props.feeTypeItem.netsuiteNonCorpItemId || ''} disabled={!canEdit || isBusy}>
                                        {netSuiteItemsOptions}
                                    </FormControl>
                                </InputCollection>
                            </div>
                          
                        </Row>

                        <Row>
                            <div className="col-md-12">
                                <hr className="form-divider" />
                                <div className="form-action-buttons" style={{ marginBottom: "20px" }}>
                                    <Button bsStyle="default" onClick={() => props.cancelled()} className="button-group-margin" disabled={isBusy}>
                                        <i className="fa fa-undo button-icon"></i>
                                        Back
                                    </Button>
                                    <Button bsStyle="danger" variant="danger" type="submit" className="button-group-margin" disabled={isBusy}>
                                        <i className="fa fa-save button-icon"></i>
                                            {isBusy ? 'Saving...' : 'Save & Exit'}
                                    </Button>
                                </div>
                            </div>
                        </Row>
                    </Form>
                )
            }
        </>
    );
}

export default withModal(withForm(FeeTypeModal));
